import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core'
import { LoadingService } from '../../services/loading.service'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BaseLoadingComponent implements OnInit, OnDestroy {
  value = false
  message: string | null = null
  destroy = new Subject<void>()

  constructor(public loadingService: LoadingService, protected cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.detectLoading()
  }

  ngOnDestroy() {
    this.loadingService.set({ message: null, value: false })
    this.destroy.next()
    this.destroy.unsubscribe()
  }

  detectLoading() {
    this.loadingService.loading$
      .pipe(takeUntil(this.destroy))
      .subscribe((result: { value: boolean; message: string | null }) => this.setLoading(result))
  }

  setLoading(result: { value: boolean; message: string | null }) {
    if (result == null) {
      return
    }
    requestAnimationFrame(() => {
      this.value = result.value
      this.message = result.message
      this.cdr.detectChanges()
    })
  }
}

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingComponent {
  @Input() message = ''

  readonly defaultSize = 16
  private _size: number = this.defaultSize
  @Input() set size(size: number) {
    this._size = size == null ? this.defaultSize : size
  }
  get size(): number {
    return this._size
  }

  get fontSize(): string {
    return `${this.size}px`
  }

  constructor() {}
}
